export default __webpack_public_path__ + "static/media/cfn.8fcbfdc1.png";